import moment from "moment"

import { getDateInDomainTimezone } from "../../utils/Common"

export const getSplittedDateRanges = ({
  from_date,
  to_date,
}: {
  from_date: string
  to_date: string
}) => {
  const startDate = moment(from_date)
  const endDate = moment(to_date)
  const dateRanges = []

  // Clone the start date to avoid mutating the original
  let currentStart = startDate.clone()

  while (currentStart.isBefore(endDate) || currentStart.isSame(endDate, "day")) {
    // Calculate the end of the current week
    let currentEnd = currentStart.clone().endOf("week")

    // If the calculated end date is after our target end date, use the target end date
    if (currentEnd.isAfter(endDate)) {
      currentEnd = endDate
    }

    dateRanges.push({
      from_date: getDateInDomainTimezone(currentStart, "Y-m-d") as string,
      to_date: getDateInDomainTimezone(currentEnd, "Y-m-d") as string,
    })

    // Move to the start of next week
    currentStart = currentEnd.clone().add(1, "day")
  }

  return dateRanges
}
